import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'app-new-component-item',
	templateUrl: './component-item.component.html',
	styleUrls: ['./component-item.component.scss']
})
export class NewComponentItemComponent {
	@Input() componentData;
	showToolbar = false;
	@Input() urlLink: string;
	webComponentDomain = environment.webComponentUrl;

	constructor() {}
}
